import React from 'react';
import clsx from 'clsx';
import {useLoaderData} from '@remix-run/react';
import type {Product as ProductType} from '@shopify/hydrogen/storefront-api-types';

//data
import {loader} from '~/routes/($lang)/products/$productHandle';

//components
import {Link} from 'components/Link';
import Product from 'components/product/Product';

interface Props {
  product: ProductType;
  type: 'cart' | 'product';
}

export default function FrequentlyBoughtTogether({product, type}: Props) {
  const {productSettings} = useLoaderData<typeof loader>();
  // const firstAvailableVariant = product.variants.nodes.find(
  //   (v) => v.availableForSale,
  // );
  return (
    <div className="frequently-bought-together">
      <h4 className="mb-[20px] text-[22px] font-medium">
        {productSettings?.product_settings_translations
                    ?.frequently_bought_together_label ??
          'Freguently Bought Together'}
      </h4>
      <div className={clsx(type === 'cart' && 'grid gap-8 md:grid-cols-2')}>
        <div className="relative">
          <div className="mb-[28px] grid">
            <Product product={product} quickAdd/>
          </div>
        </div>
      </div>
    </div>
  );
}
